import React from 'react';
import PropTypes from 'prop-types';

import FeatureItem from 'apps/summit/shared/FeatureItem';
import { getPackageClassName } from 'apps/summit/shared/utils/package-utils';

import styles from './index.scss';

export class FeaturePackageList extends React.Component {
  packageClassName = (featurePackage) => {
    const packageName = getPackageClassName(featurePackage.key);

    return `${styles.package} ${styles[packageName]}`;
  };

  render() {
    const { featurePackages } = this.props;

    return (
      <div className={styles.packageListBase}>
        <div className={styles.packageList}>
          {featurePackages.map((featurePackage) => (
            <div
              key={featurePackage.id}
              className={this.packageClassName(featurePackage)}
            >
              <h4 className={styles.header}>{featurePackage.title}</h4>
              <div className={styles.descriptions}>
                <p className={styles.description}>
                  {featurePackage.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.packageListFeatures}>
          {featurePackages.map((featurePackage) => (
            <div key={featurePackage.id} className={`${styles.featureList}`}>
              <div className={styles.divider} />
              {featurePackage.features.map((feature) => (
                <div key={feature.name} className={styles.featureItem}>
                  <FeatureItem feature={feature} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

FeaturePackageList.propTypes = {
  featurePackages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
      features: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ).isRequired,
  trialInfo: PropTypes.shape({
    trialLength: PropTypes.number
  })
};

FeaturePackageList.defaultProps = {
  trialInfo: null
};

export default FeaturePackageList;
